/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SAMLProvider
 */
export interface SAMLProvider {
    /**
     * 
     * @type {number}
     * @memberof SAMLProvider
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    readonly loginUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    readonly logoutUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    readonly metadataUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    readonly assertionUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    ssoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    sloUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    certificate: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    spCertificate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    spCertificateKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SAMLProvider
     */
    nameidFormat?: SAMLProviderNameidFormatEnum;
}

/**
* @export
* @enum {string}
*/
export enum SAMLProviderNameidFormatEnum {
    _11nameidFormatunspecified = 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
    _11nameidFormatemailAddress = 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
    _20nameidFormatpersistent = 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
    _11nameidFormatWindowsDomainQualifiedName = 'urn:oasis:names:tc:SAML:1.1:nameid-format:WindowsDomainQualifiedName',
    _11nameidFormatX509SubjectName = 'urn:oasis:names:tc:SAML:1.1:nameid-format:X509SubjectName',
    _20nameidFormatkerberos = 'urn:oasis:names:tc:SAML:2.0:nameid-format:kerberos',
    _20nameidFormatentity = 'urn:oasis:names:tc:SAML:2.0:nameid-format:entity',
    _20nameidFormattransient = 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
    _20nameidFormatencrypted = 'urn:oasis:names:tc:SAML:2.0:nameid-format:encrypted'
}

export function SAMLProviderFromJSON(json: any): SAMLProvider {
    return SAMLProviderFromJSONTyped(json, false);
}

export function SAMLProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLProvider {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'loginUrl': json['login_url'],
        'logoutUrl': json['logout_url'],
        'metadataUrl': json['metadata_url'],
        'assertionUrl': json['assertion_url'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'entityId': json['entity_id'],
        'ssoUrl': json['sso_url'],
        'sloUrl': !exists(json, 'slo_url') ? undefined : json['slo_url'],
        'certificate': json['certificate'],
        'spCertificate': !exists(json, 'sp_certificate') ? undefined : json['sp_certificate'],
        'spCertificateKey': !exists(json, 'sp_certificate_key') ? undefined : json['sp_certificate_key'],
        'nameidFormat': !exists(json, 'nameid_format') ? undefined : json['nameid_format'],
    };
}

export function SAMLProviderToJSON(value?: SAMLProvider | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'entity_id': value.entityId,
        'sso_url': value.ssoUrl,
        'slo_url': value.sloUrl,
        'certificate': value.certificate,
        'sp_certificate': value.spCertificate,
        'sp_certificate_key': value.spCertificateKey,
        'nameid_format': value.nameidFormat,
    };
}


